var _path, _path2, _rect, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMainLogoIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 38,
    viewBox: "0 0 59 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 9.98788C0 4.54602 4.4115 0.134521 9.85336 0.134521H49.1466C54.5885 0.134521 59 4.54602 59 9.98788H0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1467 14.7944L49.1467 0.134556C54.5886 0.134556 59.0001 4.54605 59.0001 9.98792L59.0001 14.7944L49.1467 14.7944Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 24.5298,
    y: 28.0078,
    width: 35.3715,
    height: 10.4518,
    transform: "rotate(-37.4505 24.5298 28.0078)",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5132 28.0125L58.9999 28.0125C58.9999 33.4543 54.5884 37.8658 49.1466 37.8658H30.5213C27.2031 37.8658 24.5132 35.1759 24.5132 31.8577V28.0125Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 14.0735H26.556C26.556 19.5153 22.1445 23.9268 16.7026 23.9268H0V14.0735Z",
    fill: "#0050EF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 28.0125H20.3075C20.3075 33.4543 15.896 37.8658 10.4542 37.8658H0V28.0125Z",
    fill: "#0050EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainLogoIcon);
export default __webpack_public_path__ + "static/media/main_logo-icon.9e68678030769ffe45769bedb2eb9f1d.svg";
export { ForwardRef as ReactComponent };